export const emptyStats = {type: "",size: "",alignment: "",hasSpellCasting: false,initiativeBonus: 0,speed: {walk: {mt: 0,ft: 0,sq: 0},fly: {mt: 0,ft: 0,sq: 0},swim: {mt: 0,ft: 0,sq: 0},climb: {mt: 0,ft: 0,sq:0},burrow:{mt:0,ft:0,sq:0},other:""},stats:{str:10,dex:10,con:10,int:10,wis:10,cha:10,strSave:0,dexSave:0,conSave:0,intSave:0,wisSave:0,chaSave:0,},otherStats:{skills:"",damageVulnerabilities:"",damageResistances:"",damageImmunities:"",conditionImmunities:"",senses:{passivePerception:0,darkvision:{distance:{mt:0,ft:0,sq:0},text:""},blindsight:{distance:{mt:0,ft:0,sq:0},text:""},tremorsense:{distance:{mt:0,ft:0,sq:0},text:""},truesight:{distance:{mt:0,ft:0,sq:0},text:""}},languages:"",challenge:""},proficiencyBonus:"",equipmentText:"",equipment:[],reactionsText:"",reactions:[],traitsText:"",traits:[],actionsText:"",actions:[],bonusActionsText:"",bonusActions:[],legendaryActionsText:"",legendaryActions:[],spellcasting:{}}
export const emptyRow = {id: 0, encounterStats: {expanded: true, initiative: 0, name:"", hp:0, maxHp:0, tempHp:0, ac:0, conditions: "", reaction: false}, creatureStats: emptyStats as unknown as CreatureStats};


export type RowObject = { 
    id: number,
    encounterStats: EncounterStats,
    creatureStats: CreatureStats
}

export type distance = {
    mt: number,
    ft: number,
    sq: number
}

export type SpeedObject = {
    walk: distance,
    fly: distance,
    swim: distance,
    climb: distance,
    burrow: distance
    other: string
}

export type EncounterStats={
    expanded: boolean,
    initiative: number, 
    name: string, 
    hp: number, 
    maxHp: number, 
    tempHp: number, 
    ac: number, 
    conditions: string, 
    reaction: boolean,
}
export type CreatureStats = {
    type: string,
    size: string,
    alignment: string,
    hasSpellCasting: boolean,
    initiativeBonus: number,
    isPlayer: boolean,
    speed: SpeedObject,
    stats: {
        str: number,
        dex: number,
        con: number,
        int: number,
        wis: number,
        cha: number,
        strSave: number,
        dexSave: number,
        conSave: number,
        intSave: number,
        wisSave: number,
        chaSave: number,
    },
    otherStats: {
        skills: string,
        damageVulnerabilities: string,
        damageResistances: string,
        damageImmunities: string,
        conditionImmunities: string,
        senses: {
            passivePerception: number,
            darkvision: {
                distance: distance,
                text: string,
            },
            blindsight: {
                distance: distance,
                text: string,
            },
            tremorsense: {
                distance: distance,
                text: string,
            },
            truesight: {
                distance: distance,
                text: string,
            },
        }
        // senses: string,
        languages: string,
        challenge: string
    },
    proficiencyBonus: number,
    equipmentText: string,
    equipment: {
        title: string,
        description: string
    }[],
    traitsText: string,
    traits: {
        title: string,
        description: string
    }[],
    actionsText: string,
    actions: {
        title: string,
        description: string
    }[],
    bonusActionsText: string,
    bonusActions: {
        title: string,
        description: string
    }[],
    legendaryActionsText: string,
    legendaryActions: TitleDescriptionObject[],
    reactionsText: string,
    reactions: TitleDescriptionObject[],
    spellcasting: {
        spellCharacteristic: string,
        spellSave: number,
        spellAttackMod: number,
        spellGroups: SpellGroup[]
    }
}

export type SpellGroup = {
    label: string,
    // level: number,
    hasSlotsGroup: boolean,
    hasSlotsEach: boolean,
    remainingSlots: number,
    maxSlots: number,
    list: Spell[]
}

export type Spell= {
    remainingSlots: number,
    description: string,
    higherLevel: string,
    name: string,
    range: distance,
    otherRange: string,
    // components: string[],
    components: {
        v: boolean,
        s: boolean,
        m: boolean,
    }
    materials: string;
    ritual: boolean,
    duration: string,
    concentration: boolean
    castingTime: string,
    level: number,
    attackType: string,
    damage: {
        type: string
    }
    dc: {
        type: string,
        success: string
    },
    areaOfEffectType: string,
    areaOfEffectSize: distance
    school: string,
    classes: string,
    subclasses: string
}

export type TitleDescriptionObject = {
    title: string,
    description: string,
}